module.exports = __webpack_public_path__ + "img/loginwallpaper.9d1d0149.jpg";